import ReactGA from 'react-ga'
import AddToHomeScreen from './components/AddToHomeScreen'
import React, { Component } from 'react'
import styled from 'styled-components'
import Router from 'react-router-dom/BrowserRouter'
import Switch from 'react-router-dom/Switch'
import Route from 'react-router-dom/Route'
import { withRouter, Redirect } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  OnBoarding,
  LoginAndSignup,
  Dashboard,
  Home,
  List,
  Products,
  Meals,
  PrivacyPolicy,
  SingleProduct,
  AboutUs,
  SingleList,
  OrderNow,
  ProductScanning,
  NominateBrand,
  NominateGrocery,
  ScanReceipt,
  UserProfile,
  EditProfile,
  ChangePassword,
  SpreadWord,
  OurTeam,
  FAQs,
  Blogs,
  Feedback,
  SingleFAQ,
  ResetPassword,
  ViewMore,
  Category,
  ProductType,
  BugAutomation,
  ViewMoreFiltered,
  ScanReceiptAutomation,
  ViewPurchasedProducts,
  AddPurchaseProducts,
  UpdatePurchaseProducts,
  RewardOption,
  ViewUserRedemption,
  AddNotification,
  ViewNotifications,
  ViewSingleNotifications,
  UserFeedback,
  ViewUsers,
  AddRecallWarning,
  ViewRecallWarning,
  ViewUpcCode,
  UpdateUpcCode
} from './pages'
import Cookies from 'js-cookie'
import axios from 'axios'
import { API_URL } from './constants'
// import qs from 'qs'
import { XCMText, FlexWrapper, Modal, Span, Card, Icon, Toast, XMText } from './components'
import { get, some, includes } from 'lodash'

ReactGA.initialize('UA-129080952-2', {
  debug: false,
  gaOptions: {
    userId: Cookies.get('user_id')
  }
})

const PrivateOnlyRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      // Checking the access_token
      if (Cookies.get('access_token')) {
        const data = Cookies.getJSON('userDetails')
        Cookies.set('redirect', data.stage, { path: '/', expires: 365 })
        axios.defaults.headers['Authorization'] = `${Cookies.get('access_token')}`
        return (
          <React.Fragment>
            {Cookies.get('addtohomescreen') || get(data, 'saveToHomeScreen', true) === true ? '' : <AddToHomeScreen />}
            <Component {...props} />
          </React.Fragment>
        )
      } else {
        return (
          <Redirect
            to={{
              pathname: '/auth/social-login'
            }}
          />
        )
      }
    }}
  />
)

const PublicOnlyRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const token = Cookies.get('access_token')
      const page = Cookies.get('currentPage')
      return token ? (
        // <Redirect to={{ pathname: page || '/home' }} />
        <Redirect to={{ pathname: page || '/scan-receipt-automation-native' }} />
      ) : (
        <React.Fragment>
          {props.location.pathname !== '/' && !Cookies.get('addtohomescreen') && <AddToHomeScreen />}
          <Component {...props} />
        </React.Fragment>
      )
    }}
  />
)
class Analytics extends React.Component {
  async componentDidMount() {
    if (Cookies.get('currentPage')) {
      this.props.history.push(Cookies.get('currentPage'))
      return
    }

    window.eval(
      'var OneSignal= window.OneSignal || [];OneSignal.push(function(){OneSignal.init({appId:"d4273cab-7c1f-4072-ad46-c75edb1786cc",autoRegister:!0,notifyButton:{enable:!1},welcomeNotification:{disable:!0},safari_web_id:"web.onesignal.auto.009a4322-838f-4341-bf26-c81fd75aa063"})});'
    )

    try {
      this.sendPageChange(this.props.location.pathname, this.props.location.search)
    } catch (error) {
      console.log(error)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.search !== prevProps.location.search
    ) {
      this.sendPageChange(this.props.location.pathname, this.props.location.search)
    }
  }

  async sendPageChange(pathname, search = '') {
    const page = pathname + search
    ReactGA.set({ page })
    ReactGA.ga('set', 'dimension1', navigator.standalone ? 'native' : 'web')
    ReactGA.pageview(page)
    Cookies.set('currentPage', pathname, { path: '/', expires: 10 / 1440 })

    const data = Cookies.getJSON('userDetails')
    if (data && data.saveToHomeScreen === false && navigator.standalone) {
      await axios.patch(`${API_URL}/users/${Cookies.get('user_id')}?access_token=${Cookies.get('access_token')}`, {
        saveToHomeScreen: true
      })
    }
  }
  render() {
    return null
  }
}
const AnalyticsTracker = () => {
  return <Route component={Analytics} />
}

class ScrollToTop extends Component {
  componentDidMount() {
    const native = window.location.pathname.indexOf('native') > -1
    this.props.history.listen((location, action) => {
      if (this.props.history.length <= 2 && !native) {
       // this.props.history.push('/home')
       this.props.history.push('/scan-receipt-automation-native')
      }
    })
  }
  componentDidUpdate(prevProps) {
    const avoidScrollToTop = ['/green-score', '/basic-info', '/grocery-store']
    // console.log(this.props.match)
    if (
      this.props.location.pathname !== prevProps.location.pathname &&
      !some(avoidScrollToTop, el => includes(this.props.location.pathname, el))
    ) {
      window.scrollTo(0, 0)
    }
  }
  render() {
    return this.props.children
  }
}

const RoutedScroll = withRouter(ScrollToTop)

class App extends Component {
  state = {
    showModal: true,
    openToast: false
  }
  handleClose = async (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    await this.setState({ openToast: false })
  }
  copyRef = React.createRef()
  createMarkeup = content => ({
    __html: content
  })
  render() {
    /*   if ('standalone' in window.navigator && !window.navigator.standalone) {
      alert('full screen')
    } else {
      console.log('standalone', window)
    } */

    const native = window.location.pathname.indexOf('native') > -1
    const { showModal, openToast } = this.state
    if (!native) {
      return (
        <React.Fragment>
          <Modal title="Download the GreenChoice Beta App" show={showModal}>
            <FlexWrapper alignItems="center">
              <XCMText>
                We are available for <br /> iOS and Android!
              </XCMText>
              <Card
                boxShadow=" 0 2px 4px 0 rgba(0, 0, 0, 0.16)"
                boxRadius="100px"
                padding="12px 18px"
                margin="10px 0 0 0">
                <FlexWrapper direction="row" alignItems="center" justifyContent="align-left">
                  <img
                    src="http://icons.iconarchive.com/icons/johnathanmac/mavrick/256/App-Store-icon.png"
                    alt="app store"
                    width={20}
                  />
                  <CopyToClipboard text={'http://bit.ly/gc-ios'} onCopy={() => window.open('http://bit.ly/gc-ios')}>
                    <Span style={{ padding: '0 0 0 15px' }}>http://bit.ly/gc-ios</Span>
                  </CopyToClipboard>
                </FlexWrapper>
              </Card>
              <Card
                boxShadow=" 0 2px 4px 0 rgba(0, 0, 0, 0.16)"
                boxRadius="100px"
                padding="12px 18px"
                margin="10px 0 0 0">
                <FlexWrapper direction="row" alignItems="center" justifyContent="align-left">
                  <img
                    src="http://icons.iconarchive.com/icons/dakirby309/simply-styled/256/Google-Play-Store-alt-icon.png"
                    alt="play store"
                    width={20}
                  />
                  <CopyToClipboard text={'http://bit.ly/gc-and'} onCopy={() => window.open('http://bit.ly/gc-and')}>
                    <Span style={{ padding: '0 0 0 15px' }}>http://bit.ly/gc-and</Span>
                  </CopyToClipboard>
                </FlexWrapper>
              </Card>
            </FlexWrapper>
          </Modal>
          <Toast open={openToast} message="Copied to clipboard!" onClose={this.handleClose} />
        </React.Fragment>
      )
    }
    if (/CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent)) {
      return (
        <React.Fragment>
          <Modal title="SORRY!" show={showModal}>
            <FlexWrapper alignItems="center">
              <XCMText>Please use the GreenChoice app in the Safari browser</XCMText>
              <Card
                boxShadow=" 0 2px 4px 0 rgba(0, 0, 0, 0.16)"
                boxRadius="100px"
                padding="12px 18px"
                margin="10px 0 0 0">
                <FlexWrapper direction="row" alignItems="center" justifyContent="align-left">
                  <img
                    src="http://icons.iconarchive.com/icons/johanchalibert/mac-osx-yosemite/1024/safari-icon.png"
                    alt="safari"
                    width={20}
                  />
                  <CopyToClipboard
                    text={'https://app.greenchoice.io'}
                    onCopy={() => this.setState({ openToast: true })}>
                    <Span style={{ padding: '0 0 0 15px' }}>
                      https://app.greenchoice.io
                      <Icon icon="copyToClipboard" />
                    </Span>
                  </CopyToClipboard>
                </FlexWrapper>
              </Card>
            </FlexWrapper>
          </Modal>
          <Toast open={openToast} message="Copied to clipboard!" onClose={this.handleClose} />
        </React.Fragment>
      )
    } else {
      return (
        <Router>
          <RoutedScroll>
            {!native && <AnalyticsTracker />}
            <Switch>
              <PublicOnlyRoute exact path="/" component={OnBoarding} />
              <PublicOnlyRoute exact path="/auth/:tab" component={LoginAndSignup} />
              <PublicOnlyRoute exact path="/reset-password/:id/:token" component={ResetPassword} />
              <PrivateOnlyRoute exact path="/dashboard/:tab" component={Dashboard} />
              <PrivateOnlyRoute exact path="/dashboard/:tab/edit" component={Dashboard} />
              <PrivateOnlyRoute exact path="/home" component={Home} />
              <PrivateOnlyRoute exact path="/lists" component={List} />
              <PrivateOnlyRoute exact path="/lists/:tab" component={SingleList} />
              <PrivateOnlyRoute exact path="/lists/:tab/:tab1" component={SingleList} />
              <PrivateOnlyRoute exact path="/lists/:tab/:tab1/:tab" component={OrderNow} />
              <PrivateOnlyRoute exact path="/products" component={Products} />
              <Route exact path="/products/:tab" component={SingleProduct} />
              <Route exact path="/products/:tab/:tab1" component={SingleProduct} />
              <PrivateOnlyRoute exact path="/meals" component={Meals} />
              <PrivateOnlyRoute exact path="/productscanning" component={ProductScanning} />
              <PrivateOnlyRoute exact path="/scan-receipt" component={ScanReceipt} />
              <PrivateOnlyRoute exact path="/gcnow-stories" component={Blogs} />
              <PrivateOnlyRoute exact path="/favorites" component={ViewMore} />
              <PrivateOnlyRoute exact path="/best-for-you" component={ViewMoreFiltered} />
              <PrivateOnlyRoute exact path="/best-scores" component={ViewMoreFiltered} />
              <PrivateOnlyRoute exact path="/recently-searched" component={ViewMore} />
              <PrivateOnlyRoute exact path="/gcnow-stories/:key" component={Blogs} />
              {/* <PrivateOnlyRoute exact path="/favorites" component={AllFavorites} /> */}
              <PrivateOnlyRoute exact path="/user-profile" component={UserProfile} />
              <PrivateOnlyRoute exact path="/user-profile/edit" component={EditProfile} />
              <PrivateOnlyRoute exact path="/user-profile/change-password" component={ChangePassword} />
              <PrivateOnlyRoute exact path="/nominate-grocery" component={NominateGrocery} />
              <PrivateOnlyRoute exact path="/nominate-brand" component={NominateBrand} />
              <PrivateOnlyRoute exact path="/invite" component={SpreadWord} />
              <Route exact path="/our-team" component={OurTeam} />
              <Route exact path="/faq" component={FAQs} />
              <Route exact path="/faq/native" component={FAQs} />
              <Route exact path="/faq/:tab" component={SingleFAQ} />
              <Route exact path="/faq/:tab/native" component={SingleFAQ} />
              <Route exact path="/aboutus" component={AboutUs} />
              <Route exact path="/aboutus/native" component={AboutUs} />
              <Route exact path="/privacy-policy" component={PrivacyPolicy} />
              <Route exact path="/privacy-policy/native" component={PrivacyPolicy} />
              <PrivateOnlyRoute exact path="/feedback" component={Feedback} />
              <PrivateOnlyRoute exact path="/category/:tab" component={Category} />
              <PrivateOnlyRoute exact path="/category/:tab/:tab1" component={ProductType} />
              {/*<PrivateOnlyRoute exact path="/bug-automation-native" component={BugAutomation} /> */}
              <PrivateOnlyRoute exact path="/scan-receipt-automation-native" component={ScanReceiptAutomation} />
              <PrivateOnlyRoute exact path="/view-purchased-automation-native/:id" component={ViewPurchasedProducts} />
              <PrivateOnlyRoute exact path="/add-purchased-products-native/:id/:userId" component={AddPurchaseProducts} />
              <PrivateOnlyRoute exact path="/edit-purchased-products-native/:id" component={UpdatePurchaseProducts} />
              <PrivateOnlyRoute exact path="/reward-options-native" component={RewardOption} />
              <PrivateOnlyRoute exact path="/view-user-redemption-native/:id" component={ViewUserRedemption} />
              <PrivateOnlyRoute exact path="/add-notification-native" component={AddNotification} />
              <PrivateOnlyRoute exact path="/view-notification-native" component={ViewNotifications} />
              <PrivateOnlyRoute exact path="/view-notification-native/:id" component={ViewSingleNotifications} />
              <PrivateOnlyRoute exact path="/user-feedback-native" component={UserFeedback} />
              <PrivateOnlyRoute exact path="/view-users-native" component={ViewUsers} />
              <PrivateOnlyRoute exact path="/add-recall-warning-native" component={AddRecallWarning} />
              <PrivateOnlyRoute exact path="/view-recall-warning-native" component={ViewRecallWarning} />
              <PrivateOnlyRoute exact path="/view-upccode-native" component={ViewUpcCode} />
              <PrivateOnlyRoute exact path="/add-upccode-native/:id" component={UpdateUpcCode} />
              <Redirect
                to={{
                  pathname: '/'
                }}
              />
            </Switch>
          </RoutedScroll>
        </Router>
      )
    }
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js